export const AppSelect = {
  STATUS: [
    { value: 0, label: 'Chưa kích hoạt', color: '#FF9500' },
    { value: 1, label: 'Đã kích hoạt', color: '#5CB85C' },
    { value: 2, label: 'Đã Xóa', color: '#FF0000' },
  ],
  STATUS_CURRICULUM: [
    { value: 0, label: 'Dừng', color: '#FF9500' },
    { value: 1, label: 'Hoạt động', color: '#5CB85C' },
    { value: 2, label: 'Đã Xóa', color: '#FF0000' },
  ],
};
